import { render, staticRenderFns } from "./ShippingDownloadFilesModal.vue?vue&type=template&id=08a335dc&scoped=true&"
import script from "./ShippingDownloadFilesModal.vue?vue&type=script&lang=js&"
export * from "./ShippingDownloadFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDownloadFilesModal.vue?vue&type=style&index=0&id=08a335dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a335dc",
  null
  
)

component.options.__file = "ShippingDownloadFilesModal.vue"
export default component.exports